import React from "react";

const DataContext = React.createContext({
  numberOfUnreadMessages: 0,
  NotificationData: [],
  onReadMessage: () => {},
  notificationData: {
    reacted: "",
    followed: "",
    joined_group: "",
    left_group: "",
    private_message: "",
    picture_comment: "",
  },
});

export default DataContext;
